// Auto-generated from solutions-app-store.html. Verbatim redesign import. Do NOT edit.
export const SCRIPT = `
(function(){
  // hero constellation canvas (lives outside .ix-scope)
  var cv=document.getElementById('appHeroCanvas');
  var reducedH=window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  if(cv && !reducedH){
    var ctx=cv.getContext('2d'), W,H,DPR,nodes,hubs,raf2,t=0,running2=false;
    function size(){ DPR=Math.min(window.devicePixelRatio||1,2); var r=cv.getBoundingClientRect(); W=r.width;H=r.height; cv.width=W*DPR;cv.height=H*DPR; ctx.setTransform(DPR,0,0,DPR,0,0); }
    function build(){ var n=Math.round(Math.min(96,Math.max(40,W/18))); nodes=[]; for(var i=0;i<n;i++){ nodes.push({x:Math.random()*W,y:Math.random()*H,vx:(Math.random()-0.5)*0.20,vy:(Math.random()-0.5)*0.20,r:Math.random()*1.8+0.8}); }
      // a few hub nodes: larger, with a pulsing halo, anchored loosely
      hubs=[]; var hn=Math.max(3,Math.round(W/520));
      for(var h=0;h<hn;h++){ hubs.push({x:(0.12+0.76*Math.random())*W,y:(0.16+0.7*Math.random())*H,vx:(Math.random()-0.5)*0.08,vy:(Math.random()-0.5)*0.08,ph:Math.random()*Math.PI*2}); } }
    var LINK=190;
    function frame(){ t+=0.004; ctx.clearRect(0,0,W,H);
      for(var i=0;i<nodes.length;i++){ var p=nodes[i]; p.x+=p.vx;p.y+=p.vy;
        if(p.x<0||p.x>W)p.vx*=-1; if(p.y<0||p.y>H)p.vy*=-1; }
      for(var hh=0;hh<hubs.length;hh++){ var hb=hubs[hh]; hb.x+=hb.vx; hb.y+=hb.vy; if(hb.x<0||hb.x>W)hb.vx*=-1; if(hb.y<0||hb.y>H)hb.vy*=-1; }
      // links (peer nodes) — more visible
      for(var a=0;a<nodes.length;a++){ for(var b=a+1;b<nodes.length;b++){ var dx=nodes[a].x-nodes[b].x,dy=nodes[a].y-nodes[b].y,d=Math.sqrt(dx*dx+dy*dy);
        if(d<LINK){ var al=(1-d/LINK)*0.34; ctx.strokeStyle='rgba(21,16,42,'+al.toFixed(3)+')'; ctx.lineWidth=0.7; ctx.beginPath(); ctx.moveTo(nodes[a].x,nodes[a].y); ctx.lineTo(nodes[b].x,nodes[b].y); ctx.stroke();
          // occasional travelling pulse along the link (deterministic per pair so it's stable)
          var seed=(a*7+b*13)%17; var pp=((t*0.4)+seed/17)%1;
          if(d<LINK*0.85){ var px=nodes[a].x+(nodes[b].x-nodes[a].x)*pp, py=nodes[a].y+(nodes[b].y-nodes[a].y)*pp; var pa=(1-d/LINK)*Math.sin(pp*Math.PI)*0.5;
            ctx.fillStyle='rgba(255,122,51,'+pa.toFixed(3)+')'; ctx.beginPath(); ctx.arc(px,py,1.4,0,Math.PI*2); ctx.fill(); } } } }
      // hub halos + connections from hubs to nearby nodes (champagne, brighter)
      for(var g=0;g<hubs.length;g++){ var H0=hubs[g], pulse0=0.5+0.5*Math.sin(t*2.2+H0.ph);
        for(var m=0;m<nodes.length;m++){ var ddx=H0.x-nodes[m].x,ddy=H0.y-nodes[m].y,dd=Math.sqrt(ddx*ddx+ddy*ddy);
          if(dd<LINK*1.15){ var hal=(1-dd/(LINK*1.15))*0.24; ctx.strokeStyle='rgba(168,139,74,'+hal.toFixed(3)+')'; ctx.lineWidth=0.8; ctx.beginPath(); ctx.moveTo(H0.x,H0.y); ctx.lineTo(nodes[m].x,nodes[m].y); ctx.stroke(); } }
        ctx.fillStyle='rgba(168,139,74,'+(0.55+pulse0*0.22).toFixed(3)+')'; ctx.beginPath(); ctx.arc(H0.x,H0.y,2.4+pulse0*1.0,0,Math.PI*2); ctx.fill(); }
      // nodes
      for(var k=0;k<nodes.length;k++){ var q=nodes[k], pulse=0.5+0.5*Math.sin(t*6+k); ctx.fillStyle='rgba(168,139,74,'+(0.30+pulse*0.26).toFixed(3)+')'; ctx.beginPath(); ctx.arc(q.x,q.y,q.r,0,Math.PI*2); ctx.fill(); }
      if(running2) raf2=requestAnimationFrame(frame);
    }
    function start2(){ if(running2)return; running2=true; raf2=requestAnimationFrame(frame); }
    function stop2(){ running2=false; cancelAnimationFrame(raf2); }
    size(); build(); start2();
    window.addEventListener('resize',function(){ size(); build(); });
    if('IntersectionObserver' in window){ var hio=new IntersectionObserver(function(es){es.forEach(function(e){ e.isIntersecting?start2():stop2(); });},{threshold:0.01}); hio.observe(cv); }
  }
  // cycling role word in the hero headline (crossfade swap, no visible scroll)
  (function(){
    var roles=["issuance","custody","distribution","onchain credit","identity","reporting"];
    var track=document.getElementById('appCycTrack'), wrap=document.getElementById('appCyc'), measure=document.getElementById('appCycMeasure');
    if(!track||!wrap||!measure) return;
    var spans=roles.map(function(w){ var s=document.createElement('span'); s.className='w'; s.textContent=w; track.appendChild(s); return s; });
    var idx=0;
    function measureWord(w){ measure.textContent=w; measure.style.fontSize=getComputedStyle(wrap).fontSize; return measure.getBoundingClientRect().width; }
    function setWidth(w){ if(window.matchMedia('(max-width: 760px)').matches){ wrap.style.width=''; return; } wrap.style.width=(Math.ceil(measureWord(w))+3)+'px'; }
    function show(i){ spans.forEach(function(s,k){ s.classList.remove('is-in','is-out'); if(k===i) s.classList.add('is-in'); }); setWidth(roles[i]); }
    show(0); window.addEventListener('load',function(){ setWidth(roles[idx]); }); window.addEventListener('resize',function(){ setWidth(roles[idx]); });
    var reducedC=window.matchMedia('(prefers-reduced-motion: reduce)').matches; if(reducedC) return;
    setInterval(function(){
      var prev=idx; idx=(idx+1)%roles.length;
      spans[prev].classList.remove('is-in'); spans[prev].classList.add('is-out');
      spans[idx].classList.remove('is-out'); spans[idx].classList.add('is-in');
      setWidth(roles[idx]);
    },2600);
  })();
  var root=document.querySelector('.view[data-route="/solutions/app-store"] .ix-scope')||document.querySelector('.ix-scope'); if(!root) return;
  var reduced=window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var ups=root.querySelectorAll('.reveal-up');
  if('IntersectionObserver' in window && !reduced){
    var io=new IntersectionObserver(function(es){es.forEach(function(e){ if(e.isIntersecting){ e.target.classList.add('in'); io.unobserve(e.target);} });},{threshold:0.18,rootMargin:'0px 0px -8% 0px'});
    ups.forEach(function(el){io.observe(el);});
  } else { ups.forEach(function(el){el.classList.add('in');}); }
  var steps=root.querySelector('#appSteps');
  if(steps){
    var items=steps.querySelectorAll('.ix-step');
    function setActive(idx){
      items.forEach(function(it,i){
        it.classList.toggle('active', i===idx);
        it.classList.toggle('done', i<idx);
      });
    }
    items.forEach(function(it,i){
      it.addEventListener('mouseenter',function(){ setActive(i); });
      it.addEventListener('focusin',function(){ setActive(i); });
    });
    steps.addEventListener('mouseleave',function(){ items.forEach(function(it){ it.classList.remove('active','done'); }); });
  }
  // future carousel: horizontal slider with prev/next; leading visible card gets the champagne look
  var fcar=root.querySelector('#appFcar');
  var fvp=root.querySelector('#appFcarVp');
  if(fcar && fvp){
    var cards=Array.prototype.slice.call(fcar.querySelectorAll('.ix-fc'));
    var prev=document.getElementById('appFprev'), next=document.getElementById('appFnext');
    var idx=0;
    function step(){ // card width + gap
      if(cards.length<2) return cards.length?cards[0].getBoundingClientRect().width:0;
      return cards[1].getBoundingClientRect().left - cards[0].getBoundingClientRect().left;
    }
    function maxIdx(){
      var vpw=fvp.getBoundingClientRect().width, s=step();
      if(s<=0) return 0;
      var total=fcar.scrollWidth;
      var m=Math.ceil((total - vpw)/s - 0.02);
      return Math.max(0, Math.min(cards.length-1, m));
    }
    function clamp(n){ var m=maxIdx(); return Math.max(0, Math.min(m, n)); }
    function render(){
      idx=clamp(idx);
      var s=step();
      fcar.style.transform='translateX('+(-idx*s)+'px)';
      cards.forEach(function(c,i){ c.classList.toggle('lead', i===idx); });
      if(prev) prev.disabled = idx<=0;
      if(next) next.disabled = idx>=maxIdx();
    }
    if(prev) prev.addEventListener('click',function(){ idx--; render(); });
    if(next) next.addEventListener('click',function(){ idx++; render(); });

    // pointer drag
    var dragging=false, startX=0, startTx=0, moved=0, s0=0;
    function curTx(){ var s=step(); return -idx*s; }
    fcar.addEventListener('pointerdown',function(e){
      if(e.button && e.button!==0) return;
      dragging=true; moved=0; startX=e.clientX; startTx=curTx(); s0=step();
      fcar.classList.add('is-dragging');
      try{ fcar.setPointerCapture(e.pointerId); }catch(_){}
    });
    fcar.addEventListener('pointermove',function(e){
      if(!dragging) return;
      var dx=e.clientX-startX; moved=Math.abs(dx);
      // rubber-band clamp so you can't drag far past the ends
      var m=maxIdx(), minTx=-m*s0, maxTx=0;
      var tx=startTx+dx;
      if(tx>maxTx) tx=maxTx+(tx-maxTx)*0.35;
      if(tx<minTx) tx=minTx+(tx-minTx)*0.35;
      fcar.style.transform='translateX('+tx+'px)';
    });
    function endDrag(e){
      if(!dragging) return; dragging=false;
      fcar.classList.remove('is-dragging');
      try{ fcar.releasePointerCapture(e.pointerId); }catch(_){}
      var dx=e.clientX-startX, s=step();
      if(s>0 && Math.abs(dx)>s*0.18){ idx=clamp(idx - Math.round(dx/s)); }
      render();
    }
    fcar.addEventListener('pointerup',endDrag);
    fcar.addEventListener('pointercancel',endDrag);
    // click a card to lead it, but ignore the click that ends a real drag
    cards.forEach(function(c,i){ c.addEventListener('click',function(){ if(moved>6) return; idx=i; render(); }); });

    var rt; window.addEventListener('resize',function(){ clearTimeout(rt); rt=setTimeout(render,120); });
    render();
  }
  // <<<GR_START>>> app-store: build your stack (grid select -> assembled stack)
  (function(){
    var view=document.querySelector('.view[data-route="/solutions/app-store"]')||document;
    var stage=view.querySelector('#appGrStage'); if(!stage) return;
    var cv=view.querySelector('#appGridCanvas'); if(!cv) return;
    var reduced=window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    var ctx=cv.getContext('2d'), W,H,DPR,S;
    var LAVA='255,117,28', CHAMP='168,139,74', CHAMPD='138,110,58', INK='21,16,42';
    var codes=['ISS','CUS','DIS','UTL','IDN','RPT'];
    var names=['Issuance','Custody','Distribution','Utility','Identity','Reporting'];
    var COLS=4, ROWS=5, NSEL=6;
    var selOrder=[2,7,9,12,16,19];          // catalogue cells that get picked, in order
    function size(){ DPR=Math.min(window.devicePixelRatio||1,2); W=cv.clientWidth;H=cv.clientHeight; cv.width=W*DPR;cv.height=H*DPR; ctx.setTransform(DPR,0,0,DPR,0,0); S=Math.min(W/620,H/520); if(S<=0||!isFinite(S))S=1; }
    window.addEventListener('resize',size); size();
    function eo(x){ return 1-Math.pow(1-x,3); }
    function ei(x){ return x*x*x; }
    function lerp(a,b,t){ return a+(b-a)*t; }
    function rr(x,y,w,h,r){ ctx.beginPath(); ctx.moveTo(x+r,y); ctx.arcTo(x+w,y,x+w,y+h,r); ctx.arcTo(x+w,y+h,x,y+h,r); ctx.arcTo(x,y+h,x,y,r); ctx.arcTo(x,y,x+w,y,r); ctx.closePath(); }
    var run=false, raf=0, t0=performance.now(), appear=0;
    function frame(now){ var t=(now-t0)*0.001; ctx.clearRect(0,0,W,H);
      appear=Math.min(1,appear+0.03); var ap=eo(appear);
      // ---- vertically centered layout ----
      var eyeH=26*S;                                 // room for the eyebrow row at top
      var blockH=Math.min(H-eyeH-20*S, 430*S);       // height shared by grid + stack
      var topY=eyeH+(H-eyeH-blockH)/2;               // equal gap above/below the block
      var gx=W*0.04, gw=W*0.50;
      var cw=gw/COLS, ch=blockH/ROWS, pad=4*S;
      var stackX=W*0.66, stackW=W*0.30, slotGap=8*S;
      var slotH=(blockH-slotGap*(NSEL-1))/NSEL;
      // eyebrows (bigger)
      ctx.textAlign='left'; ctx.textBaseline='alphabetic';
      ctx.fillStyle='rgba('+CHAMPD+',0.95)'; ctx.font='600 '+(12*S)+'px "JetBrains Mono", ui-monospace, monospace';
      ctx.fillText('APP CATALOGUE', gx, topY-11*S);
      ctx.fillText('YOUR STACK', stackX, topY-11*S);
      // timing
      var perItem=0.62, hold=1.5, total=NSEL*perItem+hold, cyc=(t%total);
      var picked=cyc/perItem, done=cyc>=NSEL*perItem;
      // stack panel
      var panX=stackX-10*S, panY=topY-6*S, panW=stackW+20*S, panH=blockH+12*S;
      rr(panX,panY,panW,panH,12*S);
      if(done){ ctx.save(); ctx.shadowColor='rgba('+LAVA+',0.45)'; ctx.shadowBlur=20; ctx.strokeStyle='rgba('+LAVA+',0.9)'; ctx.lineWidth=1.8; ctx.stroke(); ctx.restore(); }
      else { ctx.strokeStyle='rgba('+CHAMP+',0.28)'; ctx.lineWidth=1; ctx.stroke(); }
      // ---- catalogue grid ----
      var selRank={}; for(var s=0;s<selOrder.length;s++) selRank[selOrder[s]]=s;
      // helper: slot center for a given rank
      function slotXY(rank){ return [stackX+stackW/2, topY+(slotH+slotGap)*rank+slotH/2]; }
      // draw idle / ghost cells first
      for(var i=0;i<COLS*ROWS;i++){ var col=i%COLS, row=Math.floor(i/COLS);
        var x=gx+col*cw+pad, y=topY+row*ch+pad, w=cw-pad*2, h=ch-pad*2;
        var isSel=(i in selRank), rank=selRank[i];
        var prog = isSel ? Math.max(0,Math.min(1,picked-rank)) : 0;
        var gone = isSel && (prog>=1||done);
        var flying = isSel && prog>0 && prog<1 && !done;
        if(gone){ rr(x,y,w,h,5*S); ctx.fillStyle='rgba('+CHAMP+',0.05)'; ctx.fill(); ctx.strokeStyle='rgba('+CHAMP+',0.14)'; ctx.lineWidth=1; ctx.stroke(); continue; }
        if(flying) continue; // drawn later (on top)
        rr(x,y,w,h,5*S); ctx.fillStyle='rgba('+CHAMP+','+(0.04*ap)+')'; ctx.fill();
        ctx.strokeStyle='rgba('+CHAMP+','+(0.22*ap)+')'; ctx.lineWidth=1; ctx.stroke();
        ctx.fillStyle='rgba('+CHAMPD+','+(0.55*ap)+')'; ctx.font=(8.5*S)+'px "JetBrains Mono", ui-monospace, monospace'; ctx.textAlign='center'; ctx.textBaseline='middle';
        ctx.fillText(isSel?codes[rank]:'', x+w/2, y+h/2);
        if(!isSel){ ctx.fillStyle='rgba('+CHAMPD+',0.28)'; ctx.beginPath(); ctx.arc(x+w/2,y+h/2,2*S,0,7); ctx.fill(); }
      }
      // seated tiles in the stack (with connector spine + full names)
      var spineX=stackX-4*S;
      for(var k=0;k<NSEL;k++){ var prog=Math.max(0,Math.min(1,picked-k)); if(!(prog>=1||done)) continue;
        var sc=slotXY(k), sy=sc[1]-slotH/2;
        // connector from spine into tile
        ctx.strokeStyle='rgba('+CHAMP+',0.4)'; ctx.lineWidth=1; ctx.beginPath(); ctx.moveTo(spineX,sc[1]); ctx.lineTo(stackX,sc[1]); ctx.stroke();
        rr(stackX,sy,stackW,slotH,6*S);
        ctx.fillStyle='rgba('+CHAMP+',0.12)'; ctx.fill(); ctx.strokeStyle='rgba('+CHAMP+',0.6)'; ctx.lineWidth=1; ctx.stroke();
        ctx.fillStyle='rgba('+INK+',0.9)'; ctx.font=(12*S)+'px "Source Serif 4", serif'; ctx.textAlign='left'; ctx.textBaseline='middle';
        ctx.fillText(names[k], stackX+14*S, sc[1]);
        ctx.fillStyle='rgba('+CHAMP+',1)'; ctx.beginPath(); ctx.arc(stackX+stackW-12*S,sc[1],2.6*S,0,7); ctx.fill();
      }
      // vertical spine linking seated tiles
      var seatedCount=done?NSEL:Math.floor(Math.min(NSEL,picked));
      if(seatedCount>0){ var a0=slotXY(0)[1], a1=slotXY(Math.min(NSEL,seatedCount)-1)[1];
        ctx.strokeStyle='rgba('+CHAMP+',0.3)'; ctx.lineWidth=1.4; ctx.beginPath(); ctx.moveTo(spineX,a0); ctx.lineTo(spineX,a1); ctx.stroke(); }
      // flying tile(s) on top, with a connector line trailing from origin cell
      for(var f=0;f<NSEL;f++){ var prog2=Math.max(0,Math.min(1,picked-f)); if(!(prog2>0&&prog2<1)||done) continue;
        var idx=selOrder[f], col=idx%COLS, row=Math.floor(idx/COLS);
        var ox=gx+col*cw+pad, oy=topY+row*ch+pad, ow=cw-pad*2, oh=ch-pad*2;
        var sc=slotXY(f), tx=stackX+stackW/2, ty=sc[1];
        var p=eo(prog2);
        var fx=lerp(ox+ow/2,tx,p), fy=lerp(oy+oh/2,ty,p);
        var fw=lerp(ow,stackW,p), fh=lerp(oh,slotH,p);
        // guide line from origin to destination
        ctx.strokeStyle='rgba('+LAVA+','+(0.5*(1-p))+')'; ctx.lineWidth=1; ctx.setLineDash([3*S,4*S]);
        ctx.beginPath(); ctx.moveTo(ox+ow/2,oy+oh/2); ctx.lineTo(tx,ty); ctx.stroke(); ctx.setLineDash([]);
        rr(fx-fw/2,fy-fh/2,fw,fh,5*S);
        ctx.fillStyle='rgba('+CHAMP+','+(0.10+0.08*p)+')'; ctx.fill();
        ctx.strokeStyle='rgba('+LAVA+',1)'; ctx.lineWidth=1.7; ctx.stroke();
        // label: left-aligned throughout so it doesn't jump when it seats
        ctx.fillStyle='rgba('+INK+','+(0.55+0.4*p)+')'; ctx.font=(lerp(10,12,p)*S)+'px "Source Serif 4", serif'; ctx.textAlign='left'; ctx.textBaseline='middle';
        ctx.fillText(names[f], fx-fw/2+14*S, fy);
        // lava spark
        ctx.fillStyle='rgba('+LAVA+','+(0.7*(1-p))+')'; ctx.beginPath(); ctx.arc(lerp(ox+ow/2,tx,ei(prog2)),lerp(oy+oh/2,ty,ei(prog2)),3*S,0,7); ctx.fill();
      }
      // caption
      ctx.textAlign='center'; ctx.textBaseline='middle';
      ctx.fillStyle='rgba('+LAVA+',0.95)'; ctx.font='10px "JetBrains Mono", ui-monospace, monospace';
      ctx.fillText(done?'Y O U R   C O M P L E T E   S T A C K':'S E L E C T   F R O M   T H E   C A T A L O G U E', W/2, H-12);
      if(run&&!reduced) raf=requestAnimationFrame(frame);
    }
    if(reduced){ appear=1; frame(performance.now()); return; }
    if('IntersectionObserver' in window){
      var io=new IntersectionObserver(function(es){es.forEach(function(e){
        if(e.isIntersecting && !run){ run=true; raf=requestAnimationFrame(frame); }
        else if(!e.isIntersecting && run){ run=false; cancelAnimationFrame(raf); }
      });},{threshold:0.05}); io.observe(stage);
    } else { run=true; raf=requestAnimationFrame(frame); }
  })();
  // <<<GR_END>>>
  // <<<GR_END>>>
  var cnt=root.querySelector('.ix-count');
  if(cnt){
    var to=parseInt(cnt.getAttribute('data-to'),10)||100, done=false;
    function run(){ if(done) return; done=true; var t0=null;
      function tick(ts){ if(!t0)t0=ts; var p=Math.min(1,(ts-t0)/1100); var e=1-Math.pow(1-p,3);
        cnt.textContent=Math.round(to*e); if(p<1) requestAnimationFrame(tick); }
      requestAnimationFrame(tick);
    }
    if(reduced){ cnt.textContent=to; }
    else if('IntersectionObserver' in window){ var cio=new IntersectionObserver(function(es){es.forEach(function(e){ if(e.isIntersecting){run(); cio.unobserve(e.target);} });},{threshold:0.5}); cio.observe(cnt); }
    else run();
  }

  // featured apps search filter
  (function(){
    var view=document.querySelector('.view[data-route="/solutions/app-store"]')||document;
    var input=view.querySelector('#appSearch'), grid=view.querySelector('#appFeatGrid'), empty=view.querySelector('#appFeatEmpty');
    if(!input||!grid) return;
    var cards=Array.prototype.slice.call(grid.querySelectorAll('.app-feat'));
    input.addEventListener('input',function(){
      var q=input.value.trim().toLowerCase(), shown=0;
      cards.forEach(function(c){ var hit=!q||(c.getAttribute('data-name')||'').indexOf(q)>=0;
        c.style.display=hit?'':'none'; if(hit) shown++; });
      if(empty) empty.hidden = shown>0;
    });
  })();
})();
`;
